export const isAuth = () => localStorage.getItem('accessToken')
export const user = state => state.user
